import PropTypes from 'prop-types';
import React from 'react';

import ImageHero from '../image-hero/image-hero';
import CompanyHeader from '../company/company-header/company-header';
import PressCategory from './press-category/press-category';
import ArchiveBrowser from './archive-browser/archive-browser';
import Spacer from '../spacer/spacer';

const PressArchivePage = ({
  header,
  title,
  subtitle,
  subtitleMobile,
  archiveType,
  data,
  dispatch,
}) => {
  const { featured, archived, total, totalPages } = data;
  const archiveProps = {
    articles: archived,
    total,
    totalPages,
    dispatch,
    archiveType,
  };

  return (
    <div className="press-archive-page">
      <ImageHero
        backgroundClassName="press-headlines-hero"
        preheader={header}
        title={title}
        body={subtitle}
        bodyMobile={subtitleMobile}
        opacityLevel={0.7}
      />
      <Spacer ndsMarginClass="4" />
      <PressCategory articles={featured} displayLogoSalad />
      <CompanyHeader headerText="Archive" />
      <ArchiveBrowser {...archiveProps} />
    </div>
  );
};

PressArchivePage.propTypes = {
  header: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  subtitleMobile: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  archiveType: PropTypes.string.isRequired,
};

PressArchivePage.displayName = 'PressArchivePage';

export default PressArchivePage;
